import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

const TITLE = { accepted: "Confirm this bid", flagged: "Hold this bid for review", rejected: "Mark as not a bid" };

// Required reason for any manual bid decision; saved in the bid's history and the audit log.
export function ReasonDialog({ pending, onCancel, onSubmit }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const ok = note.trim().length >= 3;
  const close = () => { setNote(""); onCancel(); };
  const go = async () => { setBusy(true); try { await onSubmit(note.trim()); setNote(""); } finally { setBusy(false); } };
  return (
    <Dialog open={!!pending} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent data-testid="reason-dialog" className="w-[calc(100vw-2rem)] max-w-md rounded-xl">
        <DialogHeader>
          <DialogTitle>{TITLE[pending?.decision] || "Bid decision"}</DialogTitle>
          <DialogDescription>
            {pending?.bid ? `${pending.bid.author_name || "Unknown"} · $${Number(pending.bid.amount).toLocaleString()}` : ""}
            {pending?.bid?.review_flags?.length && pending.decision === "accepted" ? " · this overrides the automatic checks." : "."} A reason is required and is kept in the bid's history.
          </DialogDescription>
        </DialogHeader>
        <Textarea data-testid="reason-dialog-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Reason (at least 3 characters)" className="min-h-24 text-base sm:text-sm" autoFocus />
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" data-testid="reason-dialog-cancel" onClick={close} className="h-11 sm:h-9">Cancel</Button>
          <Button data-testid="reason-dialog-save" disabled={!ok || busy} onClick={go} className="h-11 sm:h-9 bg-stone-800 text-white">Save decision</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
